import React, { useEffect, useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices, useUploadImage } from 'hook/services';
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextareaAutosize } from '@mui/material'
import Editor from 'components/editor'
const EditModal = ({ data, handleRefresh }) => {
  const AppService = useAppServices();
  const uploadImage = useUploadImage();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [svgIcon, setSvgIcon] = useState(null);
  const [description, setDescription] = useState(data.description);
  const [answer, setAnswer] = useState(data?.answer || "false");
  const [images, setImages] = useState([]); 


  useEffect(() => {
    if (data?.image) {
      setImages(data.image); 
    }
  }, [data]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setImages((prevImages) => [...prevImages, ...files]); 
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (data?.answer !== undefined) {
      setAnswer(data.answer.toString());
    }
  }, [data]);

  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    let uploadedImages = [];

    const newImages = images.filter((image) => image instanceof File);
  
    if (newImages.length > 0) {
      try {
        const uploadPromises = newImages.map((file) =>
          uploadImage({ file, desiredPath: `app/logo/image` })
        );
        const responses = await Promise.all(uploadPromises);
        uploadedImages = responses
          .map((res) => res?.response?.data)
          .filter(Boolean);
      } catch (error) {
        console.error('Image upload failed:', error);
      }
    }

    const payload = {
      _id: data._id,
      name: e.target.name.value,
      description,
      snapshotLink: e.target.snapshotLink.value,
      image: uploadedImages.length > 0 ? [...uploadedImages, ...images.filter(image => !(image instanceof File))] : images,
      video: e.target.video.value,
    };

    const { response } = await AppService.snap_shot.update({ payload });
    console.log(response, "response");

    if (response) {
      setProcessing(false);
      closeEditProduct();
      handleRefresh();
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} encType="multipart/form-data">
            <MDTypography variant="h5" mb={2}>
              Edit Snapshot
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} data={description} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">SnapShot Link</MDTypography>
              <MDInput label="SnapShot Link" name="snapshotLink" fullWidth defaultValue={data.snapshotLink} />
            </MDBox>

            <Stack direction="row" alignItems="center" spacing={2}>
  <Button variant="contained" component="label" sx={{ color: '#fff' }}>
    Upload Images +
    <input hidden name="image" type="file" multiple onChange={handleFileChange} />
  </Button>
</Stack>

{images.length > 0 && (
  <MDBox mt={2}>
    <MDTypography variant="button">Selected Images:</MDTypography>
    <Stack direction="row" spacing={1} mt={1}>
      {images.map((file, index) => (
        <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
          <img
            src={file instanceof File ? URL.createObjectURL(file) : file} 
            alt={`preview-${index}`}
            width={50}
            height={50}
            style={{ borderRadius: 5 }}
          />
          <button
            type="button"
            onClick={() => handleRemoveImage(index)} // Remove selected image
            style={{
              position: 'absolute',
              top: -5,
              right: -5,
              background: 'rgba(255, 132, 132, 0.7)',
              color: 'red',
              border: 'none',
              borderRadius: '50%',
              cursor: 'pointer',
              width: 20,
              height: 20,
              fontSize: '16px',
              lineHeight: '16px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            &times;
          </button>
        </div>
      ))}
    </Stack>
  </MDBox>
)}


            <MDBox mb={2}>
              <MDTypography variant="button">Video Url</MDTypography>
              <MDInput label="Video Url" name="video" fullWidth defaultValue={data.video} />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};


export default EditModal;
